module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-type-title"
  }, [_c('div', {
    staticClass: "goods-type-title-left"
  }, [_c('div', {
    staticClass: "left-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "right-sub"
  }, [_vm._v("好货常换 惊喜不断")])]), _vm._v(" "), _c('div', {
    staticClass: "goods-type-title-right",
    on: {
      "click": _vm.gotoPage
    }
  }, [_c('span', [_vm._v("更多")]), _c('img', {
    attrs: {
      "src": require("../../../assets//images/right.png"),
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114a9956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner-square/title.vue
// module id = 1530
// module chunks = 1